import { DormitoryServicePath, PRICES, ROOM_TYPES } from "utils/constants";
import permissions from "app/permissions";
import CreateAccommodationPrice from "./Create";

export const resources = {
  name: `${DormitoryServicePath}${ROOM_TYPES}/:typeId/${PRICES}/create`,
  title: "Създаване на цена за настаняване",
  custom: <CreateAccommodationPrice />,
  permission: permissions.canManageDormitoryAccommodationPrices,
};
